// React Dependencies
import React, { useEffect, useState } from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Icon, MenuItem, MenuList } from '@material-ui/core';

// Internal Dependencies
import OverLoading from '../../../global/OverLoading';
import TrailRouter from './router';
import apiService from '../../../../services.js/apiService';
import { Colours, Url } from '../../../../common/constants';
import { IsEmpty } from '../../../../common/checks';
import { editPage } from '../../../../actions/admin/pageAction';

const Trail = ({ match, pageInView, dispatchEditPage }) => {
  const { pageId, trailId } = match.params;

  const [isLoading, setIsLoading] = useState(true);

  const getPageData = async () => {
    try {
      if (IsEmpty(pageId)) {
        return;
      }
      setIsLoading(true);
      const p = await apiService.getPageById(pageId);
      dispatchEditPage(p);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getPageData();
  }, [pageId]);

  if (isLoading) {
    return <OverLoading />;
  }

  return (
    <div className="container-fluid pl-0">
      <div className="row">
        <div className="col-md-12">
          <div className="d-flex justify-content-start content-header">
            <h1 className="d-flex align-items-center">
              <Link to={`${Url.Trails.replace(':pageId', pageId)}`} title="Back" className="d-flex align-items-center">
                <Icon className="back">arrow_back</Icon>
              </Link>
              {pageInView ? pageInView.name : ''}
              {` / Trail / ${trailId}`}
            </h1>
          </div>
          <div className="row">
            <div className="col-md-2" style={{ backgroundColor: Colours.White }}>
              <MenuList>
                <Link to={match.url}>
                  <MenuItem>Info</MenuItem>
                </Link>
                <Link to={`${match.url}/posts`}>
                  <MenuItem>Posts</MenuItem>
                </Link>
                <Link to={`${match.url}/reviews`}>
                  <MenuItem>Reviews</MenuItem>
                </Link>
                <Link to={`${match.url}/boundaries`}>
                  <MenuItem>Map Boundaries</MenuItem>
                </Link>
              </MenuList>
            </div>
            <div className="col-md-10 pt-3 card-left">
              <TrailRouter match={match} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

Trail.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      pageId:  PropTypes.string.isRequired,
      trailId: PropTypes.string.isRequired,
    }),
    url: PropTypes.string.isRequired,
  }).isRequired,

  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,

  pageInView: PropTypes.shape({
    id:   PropTypes.number,
    name: PropTypes.string,
  }),

  dispatchEditPage: PropTypes.func.isRequired,
};

Trail.defaultProps = {
  pageInView: { id: null, name: null },
};

const mapStateToProps = (state) => ({
  pageInView: state.admin.page.pageInView,
});

const mapDispatchToProps = (dispatch) => ({
  dispatchEditPage: (p) => dispatch(editPage(p)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Trail);
